import Service from "../../services";
import { checkAndReturn } from "../../main";

const state = {};

const getters = {};

const actions = {
  index({ commit }, params) {
    return Service.Webboard.index(params.payload).then((res) => {
      return checkAndReturn(params, res, true);
    });
  },
  deleteRequests({ commit }, params) {
    return Service.Webboard.deleteRequests(params.payload).then((res) => {
      return checkAndReturn(params, res, true);
    });
  },
  save({ commit }, params) {
    return Service.Webboard.save(params.payload).then((res) => {
      return checkAndReturn(params, res, true);
    });
  },
  show({ commit }, params) {
    return Service.Webboard.show(params.payload).then((res) => {
      return checkAndReturn(params, res, true);
    });
  },
  comment({ commit }, params) {
    return Service.Webboard.comment(params.payload).then((res) => {
      return checkAndReturn(params, res, true);
    });
  },
  requestDelete({ commit }, params) {
    return Service.Webboard.requestDelete(params.payload).then((res) => {
      return checkAndReturn(params, res, true);
    });
  },
  destroy({ commit }, params) {
    return Service.Webboard.destroy(params.payload).then((res) => {
      return checkAndReturn(params, res, true);
    });
  },
  reviewDeleteRequest({ commit }, params) {
    return Service.Webboard.reviewDeleteRequest(params.payload).then((res) => {
      return checkAndReturn(params, res, true);
    });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
